export const tasks = state => state.tasks.items
export const tasksTotal = state => state.tasks.total
export const taskById = state => id => {
    id = parseInt(id)
    return _.find(tasks(state), {id})
}
export const tasksByProjectId = state => project_id => _.filter(tasks(state), { project_id })
export const tasksByApplication = state => {
    return (project_id, application_id, application_type) => {
        return _.filter(tasks(state), { project_id, application_id, application_type })
    }
}

export const tasksByIds = state => ids => {
    return _.reduce(ids, (res, id) => {
        let task = taskById(state)(id)
        if (task) res.push(task)
        return res
    }, [])
}

export const tasksByContactId = state => id => _.filter(state.tasks.items, {contact_id: parseInt(id)})

export const taskNameById = state => id => {
    let task = taskById(state)(id)
    return task ? task.title : null
}

// Never used and can be deleted
/*
export const taskApplicationNumber = (state, getters) => task => {
    let getter = getters[task.application_type + 's/itemById']
    return getter === undefined ? '' : getter(task.application_id).application_number
}
*/